/**
 * MapVersionEntity Class file
 *
 * Generated file, don't touch manually
 *
 * ModelVersion: 90004
 */
import { BaseEntity } from "@archipad-js/core/orm";
import { MapEntity } from "../MapEntity";
import { MapVersionEntity } from "../MapVersionEntity";
declare global {
    interface EntityTypeMap {
        MapVersion: MapVersionEntity;
    }
}
export abstract class MapVersionGeneratedEntity extends BaseEntity {
    public abstract mapVersionId: string;
    public abstract filename: string;
    public abstract index: number;
    public abstract date: Date | null;
    public abstract templateId: string | null;
    public abstract cropBoxOriginX: number;
    public abstract cropBoxOriginY: number;
    public abstract cropBoxWidth: number;
    public abstract cropBoxHeight: number;
    public abstract mediaBoxOriginX: number;
    public abstract mediaBoxOriginY: number;
    public abstract mediaBoxWidth: number;
    public abstract mediaBoxHeight: number;
    public abstract rotation: number;
    public abstract map: MapEntity;
    public abstract activeForMap: MapEntity | null;
}
